import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class SearchBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ""
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSearchButtonClick = this.handleSearchButtonClick.bind(this);
        this.handleResetSearchClick = this.handleResetSearchClick.bind(this);
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    handleSearchButtonClick() {
        if (this.state.value) {
            this.props.handleSearchButtonClick(this.state.value)
        }
    }

    handleResetSearchClick() {
        // if (this.state.value && this.props.onResetSearchClick) {
        if (this.props.onResetSearchClick) {
            this.props.onResetSearchClick();
        }

        this.setState({ value: "" });
    }

    render() {
        return (
            <div className="input-group">
                <input type="text" value={this.state.value} className="form-control" placeholder={this.props.placeholder} onChange={this.handleChange} />
                <div className="input-group-append">
                    <button className="btn btn-secondary" type="button" onClick={this.handleResetSearchClick} title="Сбросить">
                        <FontAwesomeIcon icon="times" size="sm" color="#fff" />
                    </button>
                </div>
                <div className="input-group-append">
                    <button className="btn btn-secondary" type="button" onClick={this.handleSearchButtonClick} title="Искать">
                        <FontAwesomeIcon icon="search" size="sm" color="#fff" />
                    </button>
                </div>
            </div>
        );
    }
}

export default SearchBlock;